import React from "react";
import { IconProps } from "./types";

export default function VisaIcon({
  width = 24,
  height = 24,
  className = "",
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 102 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M85.3177 36.4144L84.5119 32.3853H75.5081L74.0755 36.3858L66.8588 36.4001C71.498 25.2522 74.941 16.9946 77.1878 11.6272C77.7751 10.2232 78.8173 9.50694 80.3538 9.51768C81.5285 9.52723 83.4458 9.52842 86.1056 9.52126L91.6855 36.4037L85.3177 36.4144ZM77.5316 26.8663H83.3371L81.1704 16.7666L77.5316 26.8663ZM31.0227 9.5141L38.2788 9.52126L27.0616 36.418L19.7161 36.4109C17.8689 29.3064 16.0448 22.196 14.2436 15.0797C13.8855 13.6614 13.1763 12.6694 11.8118 12.2002C10.5917 11.7824 8.5646 11.1365 5.73047 10.2626V9.52126H17.3237C19.3293 9.52126 20.5004 10.4918 20.8765 12.4831C21.2561 14.4792 22.2112 19.5577 23.7416 27.7187L31.0227 9.5141ZM48.2496 9.52126L42.5157 36.4144L35.607 36.4037L41.3302 9.5141L48.2496 9.52126ZM62.2531 9.02344C64.3196 9.02344 66.9233 9.6681 68.4204 10.2626L67.2098 15.8354C65.856 15.291 63.6284 14.5568 61.7553 14.5819C59.0333 14.6284 57.3501 15.7709 57.3501 16.8668C57.3501 18.6504 60.2725 19.5493 63.281 21.4977C66.712 23.7182 67.1668 25.713 67.1239 27.8834C67.0773 32.3781 63.281 36.8156 55.2728 36.8156C51.6197 36.7619 50.3017 36.4574 47.322 35.3973L48.5826 29.581C51.6161 30.8489 52.9019 31.2536 55.4949 31.2536C57.8694 31.2536 59.9072 30.2937 59.9251 28.6212C59.9395 27.4321 59.2088 26.8412 56.5442 25.3728C53.8796 23.9044 50.1406 21.8666 50.1907 17.7729C50.2516 12.5368 55.2119 9.02344 62.2531 9.02344Z"
        fill="black"
      />
    </svg>
  );
}
